import { Button, Stack } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import RightDrawer from "components/rightDrawer/RightDrawer";
import DateRangeField from "components/ui/dateRangeField";
import InputField from "components/ui/inputField";
import MultiSelect from "components/ui/multiSelect";
import { useFormik } from "formik";
import * as yup from "yup";
import getInitialvalues from "../../utils/filterInitialValues";

const AdvanceFilter = ({
  openDrawer,
  setOpenDrawer,
  setReload,
  setFilters,
  filters,
  isFiltering,
  pagination,
  setPagination,
  bankInvoiceStatuses,
}) => {
  const initialValues = getInitialvalues(filters);
  const validationSchema = yup.object({});
  const onSubmit = async (data) => {
    setFilters({ ...filters, ...data });
    setOpenDrawer(false);
    setPagination({ ...pagination, current_page: 1 });
    setReload((pre) => !pre);
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const resetForm = () => {
    const emptyFilter = {};
    for (const key in filters) {
      if (Array.isArray(filters[key])) {
        emptyFilter[key] = [];
      } else {
        emptyFilter[key] = null;
      }
    }
    formik.setValues(emptyFilter);
    setFilters({});
    setReload((pre) => !pre);
    setOpenDrawer(false);
  };

  return (
    <RightDrawer
      {...{
        openDrawer,
        setOpenDrawer,
        width: "400px",
        headingLeft: "Advanced Filters",
        headingRight: "",
      }}
    >
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Stack
          direction="column"
          gap="15px"
          p="20px"
          sx={{ height: "calc(100vh - 125px)", overflowY: "auto" }}
        >
          <InputField
            name="interest_amount"
            label="Interest Rate"
            type="number"
            formik={formik}
          />
          <MultiSelect
            options={bankInvoiceStatuses}
            label="Bank Invoice Status"
            value={formik?.values?.bank_invoice_status_id}
            onChange={(value) => formik.setFieldValue("bank_invoice_status_id", value)}
            selectProps={{
              id: "id",
              label: "name",
            }}
          />
          <DateRangeField
            label="Paymnet at"
            from="payment_date_from"
            to="payment_date_to"
            formik={formik}
          />
          <DateRangeField
            label="Created at"
            from="created_at_from"
            to="created_at_to"
            formik={formik}
          />
        </Stack>
        <Stack
          direction="row"
          gap="15px"
          p="10px 20px"
          justifyContent="flex-end"
        >
          {isFiltering() ? (
            <Button variant="outlined" onClick={resetForm}>
              Reset Filter
            </Button>
          ) : (
            <Button variant="outlined" onClick={() => setOpenDrawer(false)}>
              Cancel
            </Button>
          )}
          <Button
            variant="solid"
            onClick={formik.submitForm}
            disabled={!formik.dirty}
          >
            Filter Banks
          </Button>
        </Stack>
      </LocalizationProvider>
    </RightDrawer>
  );
};

export default AdvanceFilter;
